import ExaminationEventInformationFields from './ExaminationEventInformationFields';

export default ExaminationEventInformationFields;
